export default __webpack_public_path__ + "static/media/user-defoult-img.f90149bb.jpg";